import { IonCol, IonItem, IonLabel, IonList, IonThumbnail } from "@ionic/react";
import React, { FC, useEffect, useState } from "react";
import { API_URL } from "../../../actions/settings";
import { default as old_benchmarks} from "../../../AE2/static/icons/needs_attention/Benchmarks Older than 5 Years.svg"
import { default as low_score} from "../../../AE2/static/icons/needs_attention/Low Energy Star Score.svg"
import { default as warranty} from "../../../AE2/static/icons/needs_attention/Warranties Expiring Soon.svg"
import { default as missing_interval_model} from "../../../AE2/static/icons/needs_attention/Missing Interval Model Data.svg"
import NeedsAttentionModal from "./NeedsAttentionModal";

async function getData(token: string) {
  return fetch(`${API_URL}/homepage/needs_attention`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                console.log(err)
                return null
            })

        }
      }).catch(error => {
        console.log(error)
        return null
      });
}

interface Item {
    id:string,
    title:string,
    icon:string,
    url:string,
    subtitle:string

};

interface IProps {};

const items = [
    {
        'id':'old_benchmarks',
        icon: old_benchmarks,
        title:'Benchmarks Older Than 5 Years',
        subtitle:'Buildings',
        url:'/'
    },
    {
        'id':'low_score',
        icon: low_score,
        title:'Low Energy Star Score (<50)',
        subtitle:'Buildings',
        url:'/'
    },
    {
        'id':'warranties_expiring',
        icon: warranty,
        title:'Warranties Expiring Soon (90 Days)',
        subtitle:'Projects',
        url:'/'
    },
    {
        'id':'missing_interval_model',
        icon: missing_interval_model, // placeholder until a dedicated icon is added
        title:'Missing Interval Model Data',
        subtitle:'Buildings',
        url:'/'
    },

]

const NeedsAttentionCol:FC<IProps> = (props) => {
    const [itemData,setItemData] = useState<any>({})

    useEffect(() => {
        const handleData = async () => {
            const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;            
            const res = await getData(token)            
            if(res){
                setItemData(res.data)
            }
            }
        handleData()
        },[])

    return <IonCol className="grey-border-2pt w-100 bg-white" style={{marginBottom:'1rem', borderRadius:'1rem', padding:'1rem', minHeight:'fit-content'}}>
                <div className="w-100 text-dark-blue font-helvetica font-med font-18pt" style={{borderBottom:'2pt solid #F1F3F6'}} > Needs Attention</div>
                <IonList>                    
                    {items.map((item:Item) => {                        
                        if(item.id in itemData){
                            const title = <div style={{display:'flex'}}>
                                <IonThumbnail slot="start" style={{marginRight:'0.5rem', height:'100%'}}>
                                    <img src={item.icon} alt={`${item.id}-icon`} />
                                </IonThumbnail>
                                <h3 className="text-dark-blue">{item.title}</h3>
                            </div>
                            return <IonItem lines="none" key={item.id} style={{marginBottom:'1rem'}}>                                 
                                    <IonThumbnail slot="start" style={{marginRight:'0.5rem', height:'100%'}}>
                                        <img src={item.icon} alt={`${item.id}-icon`} />
                                    </IonThumbnail>                       
                                    <IonLabel>
                                        <div className="font-helvetica font-bold font-13pt text-map-main">{item.title}</div>                            
                                        <div className="font-helvetica font-med font-12pt text-footer-blue"> {itemData[item.id].count} {item.subtitle}</div>
                                    </IonLabel>                                    
                                        <NeedsAttentionModal id={item.id} title={title}/>                           
                            </IonItem>
                            
                        }
                        return null
                    })
                    }
                </IonList>
            </IonCol>
};

export default NeedsAttentionCol;